import Vue from 'vue'
import Vuex from 'vuex'

import session from './modules/session'
import settings from './modules/settings'
import menu from './modules/menu'
import commons from './modules/commons'
import notifications from './modules/notifications'
import toast from './modules/toast'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  modules: {
    session,
    settings,
    menu,
    commons,
    notifications,
    toast
  }
})
